export default {"src":"/_next/static/media/mission.d965021f.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};